import React from "react";
import Image from "next/image";
import styles from "./acheiver.module.css";
import pic1 from "../../assets/images/home/ISHITA KISHORE.webp";
import pic2 from "../../assets/images/home/YAKSH CHAUDHARY.webp";
import pic3 from "../../assets/images/home/AR-RAJAH-MOHAIDEEN-7.webp";
import pic4 from "../../assets/images/home/rajeshwari-suve-m-r-1.webp";
import pic01 from "../../assets/images/home/Rank8.png";
import pic6 from "../../assets/images/home/SHAURYA ARORA.webp";

import Link from "next/link";

const acheiverslist=[
    
    { Image: pic4, alt: "RAJESHWARI SUVE M", name: "RAJESHWARI SUVE M",  dept: "AIR 02", class:"img-fluid",cont: "SIA Sociology Optional <br/> - Naan Mudhalvan <br/> 2025"},
    { Image: pic3 , alt: "AR RAJAH MOHAIDEEN", name: "AR RAJAH MOHAIDEEN", dept: "AIR 07", class:"img-fluid",cont: "GS Prelims  <br/> - Cum Mains Foundation <br/> 2025"},
    { Image: pic01 , alt: "RAJKRISHNA JHA", name: "RAJKRISHNA JHA", dept: "AIR 8", class:"img-fluid",cont: "Civiliasation <br/> 2024"},
    { Image: pic6 , alt: "SHAURYA ARORA", name: "SHAURYA ARORA", dept: "AIR 14", class:"img-fluid",cont: "Civiliasation <br/> 2023"},
    { Image: pic1 , alt: "ISHITA KISHORE", name: "ISHITA KISHORE", dept: "AIR 01", class:"img-fluid",cont: "Civiliasation <br/> 2022"},
    { Image: pic2 , alt: "YAKSH CHAUDHARY", name: "YAKSH CHAUDHARY", dept: "AIR 06", class:"img-fluid",cont: "Mainstorming <br/> 2021"},
    
    
    
   
]
const acheiver=()=>{
    return(
        <>
        <div className="container">

        <div className="row">
          <div className="col pt-3">
            <div className={`${styles.scrollparent}`}>

                {acheiverslist.map((item,index)=>(
                    <div className={`${styles.scrolldiv} pe-lg-3 text-center pe-5`} key={index}>
                      <div style={{width: '142px', height: '165px'}} className="text-center"><Image src={item.Image} className={item.class} alt={item.alt} title={item.alt} /></div>                 
                    <p className={`${styles.acheivername} mt-2 mb-0 text-center`}>
                    {item.name}
                    </p>
                    <p className={`${styles.acheivername} mb-0 text-center`}>
                    {item.name1}
                    </p>
                    <p className={`${styles.sectionredtitle} text-center mb-0`}>{item.dept}</p>
                    <p className={`${styles.acheiverrank} text-center`} dangerouslySetInnerHTML={{ __html: item.cont }}></p>
                    
                </div>
                ))}

    
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col pt-3 pb-4 text-center">
            <Link href="/our-achievers" className={`${styles.viewbuttonalink}`}>
              <button type="button" className={`${styles.viewbutton}`}>
                View All
              </button>
            </Link>
          </div>
        </div>
      </div>
        </>
    )
}
export default acheiver;